module.exports = __webpack_public_path__ + "img/1.175e56d3.jpg";